import { useContext } from 'react';
import _noop from 'lodash/noop';

import { AppContext, ModalContext } from 'commons-ui';
import { IPermissionSetHandlerParams } from 'models/settingsV2.model';
import useService from './utils/useService';

const useHandler = (params: IPermissionSetHandlerParams) => {
	const { setForceUpdate = _noop, rowData } = params;
	const { requestDeletePermissionsSet } = useService();
	const { app, showAlert } = useContext(AppContext);
	const { setModalConfig } = useContext(ModalContext);

	const onAgreeDeletePermissionsSet = async () => {
		setModalConfig({ isOpen: false });
		try {
			const response = await requestDeletePermissionsSet(app.appName, rowData);
			if (!response?.data?.success) {
				throw new Error(response?.data?.message || 'Failed to delete permissions set');
			}
			showAlert('Permission Set deleted successfully', { type: 'success' });
			setForceUpdate(true);
		} catch (err: any) {
			const errorMessage: string = err.response?.data?.error || err?.message;
			showAlert(errorMessage ?? 'Error while deleting this Permission Set', { type: 'error' });
		}
	};
	const onDisAgreeDeletePermissionsSet = () => {
		setModalConfig({ isOpen: false });
	};

	return {
		onAgreeDeletePermissionsSet,
		onDisAgreeDeletePermissionsSet
	};
};

export default useHandler;
